import { render, staticRenderFns } from "./CustomPaymentInspector.vue?vue&type=template&id=606d458c&scoped=true&"
import script from "./CustomPaymentInspector.vue?vue&type=script&lang=js&"
export * from "./CustomPaymentInspector.vue?vue&type=script&lang=js&"
import style0 from "./CustomPaymentInspector.vue?vue&type=style&index=0&id=606d458c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606d458c",
  null
  
)

export default component.exports